export interface SplitCourseTitle {
  primaryTitle: string;
  attribution?: string;
}

export function splitCourseTitle(title: string | null | undefined): SplitCourseTitle {
  const trimmedTitle = (title ?? "").trim();
  const splitParts = trimmedTitle.split(/:\s*in collaboration with\s*/i);

  if (splitParts.length < 2) {
    return { primaryTitle: trimmedTitle };
  }

  const primaryTitle = splitParts[0].trim();
  const collaborator = splitParts.slice(1).join(": In collaboration with ").trim();

  if (!primaryTitle || !collaborator) {
    return { primaryTitle: trimmedTitle };
  }

  return {
    primaryTitle,
    attribution: `In collaboration with ${collaborator}`,
  };
}
